<svelte:options accessors={true}/>
<script>
	import InsightMetricsBuilder from './../components/InsightMetricsBuilder.svelte';
    import {onMount} from 'svelte';
    import ReportsService from "../services/reports.service";
    import Loader from "../components/Loader.svelte";
    import ColorPicker from "../components/ColorPicker.svelte";
    import EditableCell from "../components/EditableCell.svelte";
    import AuthService from '../services/auth.service.js';
    import { formatValue } from '../helpers/format.helper';
    import { getActualClass, stylesList, metricList, getPastDateData, metricOptions } from '../helpers/style.helper';
    import ExportService from "../services/export.service";
    import { calculateKpiYTDValues } from '../services/reports.service.js';

    let sections,
        kpiToChange,
        errorMessage,
        disableButton = false,
        disableSaveButton = false,
        dropped = [],
        dropped_in = '',
        sectionName = '',
        loading = false,
        deleteConfirmation = false,
        deletedItems = [],
        currentKPI = {},
        currentSection = {},
        sectionToChange = {},
        selectedSection = null,
        headers = [],
        sectionDragged,
        kpiDragged;
    const formatTitles = [
        'Numeric', 'Currency ($)', 'Percentage (%)', 'Days', 'Multiplier (x)', 'B.P.S. (bps)'
    ];

    let ytdValues = {};

    export let user, params, loadingExport = false;

    $: loadData(params);

    export async function loadData() {
        if (loading) return;
        loading = true;
        selectedSection = null;
        var e = jQuery.Event("blur", {keyCode: 27, key: 27});
        jQuery(".cellPasted").trigger(e);

        sections = null;
        ytdValues = {};
        const url = '/org/' + params.org + '/weekly/date/' + params.year + '/' + params.month;
        let result = null;

        try {
            result = await ReportsService.load(url);
            //Scroll to previous position
            setTimeout(() => {
                var scrolled = (localStorage.getItem('scrolled'))? localStorage.getItem('scrolled') : 0;
                jQuery('#reportsDiv').scrollTop(scrolled);
                localStorage.setItem("scrolled",0);
            }, 500);
        } catch (e) {
            sections = null;
            console.error('Error loading data!');
        }

        if (result && result.data){
            sections = result.data.sections;
            headers = result.data.headers;

            sections.forEach(section => {
                section.kpis.forEach(kpi => {
                    if (kpi.kpiData) {
                        ytdValues[kpi.id] = calculateKpiYTDValues(kpi, params.year, kpi.ytd_formula, params.subMenu, 'weekly');
                    } else {
                        ytdValues[kpi.id] = { actual: '', budget: '' };
                    }
                });
            });
        }
        loading = false;

        setTimeout(() => {
            jQuery('.sticky-thead').removeClass('d-none');
            tablesLoaded();
            enableTableSelection();
        }, 700);
    }

    onMount( () => {
        cleanKPI();
        loadData();
    });

    let saveKPIData = async function(value, kpi_id, date, actual, budget, elementId, valueType, kpi) {
        let body;
        if(valueType == 'actual'){
            body = { kpi_id, date, actual, locked: false, notes: 'none' };
        }else{
            body = { kpi_id, date, budget, locked: false, notes: 'none' };
        }
        // Update insight metrics data
        if(kpi.insight_metric_data && kpi.insight_metric_data.data && kpi.insight_metric_data.data[date]){
            kpi.insight_metric_data.data[date][valueType] = value;
            let totalActual = 0, totalBudget = 0, percentage ;
            Object.keys(kpi.insight_metric_data.data).map( kpiData => {
                totalActual += parseFloat(kpi.insight_metric_data.data[kpiData].actual);
                totalBudget += parseFloat(kpi.insight_metric_data.data[kpiData].budget);
            });
            const metric = JSON.parse(kpi.metric);
            let message = "";
            const amount = metric.amount;
            const ruleMessage = amount + " " + metricOptions.formats[metric.format] + " " +
              metricOptions.conditions[metric.condition] + " " + metricOptions.periods[metric.period];
            switch(metric.condition){
                case 0:
                    percentage = (totalBudget * amount) / 100;
                    if ((!kpi.inverted && totalActual <= totalBudget - percentage) || (kpi.inverted && totalActual >= totalBudget + percentage)) {
                        message = ruleMessage;
                    }
                    break;
                case 1:
                    if ((!kpi.inverted && totalActual <= totalBudget - amount) || (kpi.inverted && totalActual >= totalBudget + amount)) {
                        message = ruleMessage;
                    }
                    break;
                case 2:
                    if(totalActual - totalBudget >= amount){
                        message = ruleMessage;
                    }
                    break;
            }
            kpi.insight_metric_data.message = message;
        }

        ytdValues[kpi.id] = calculateKpiYTDValues(kpi, params.year, kpi.ytd_formula, params.subMenu, 'weekly');

        await ReportsService.saveKpiData(body);
        jQuery('#'+elementId).addClass('manual-data-kpi')
    }

    let onSaveKPI = async function() {
        disableSaveButton = true;
        errorMessage = null;

        try {
            if (currentKPI.id) {
                if(JSON.stringify(currentKPI) != JSON.stringify(kpiToChange)){
                    await ReportsService.updateKpi(currentKPI);
                }
            } else {
                await ReportsService.saveKpi(currentKPI);
            }
            await loadData();

            disableSaveButton = false;
            jQuery('#addKPI').modal('hide');
            cleanKPI();
        } catch (e) {
            errorMessage = e.message;
        }
    };

    let onSaveSection = async function() {
        disableSaveButton = true;
        errorMessage = null;
        let response = null;

        try {
            if(currentSection.id){
                if(JSON.stringify(sectionToChange) != JSON.stringify(currentSection)){
                    await ReportsService.updateSection(currentSection);
                    loadData();
                }
            }else{
                await ReportsService.saveSection(currentSection);
                loadData();
            }
            disableSaveButton = false;
            jQuery('#editSection').modal('hide');
            currentSection = {}; //"Clean" it
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onDeleteKPI = async function() {
        errorMessage = null;
        disableButton = true;

        try {
            await ReportsService.deleteKpi(currentKPI.id);
            deleteConfirmation = false;
            jQuery('#addKPI').modal('hide');
            cleanKPI();
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let setDeleteConfirmation = function (){
        deleteConfirmation = true;
        setTimeout(() => {
            if (deleteConfirmation) deleteConfirmation = false;
        }, 3000);
    }

    function cleanKPI() {
        currentKPI = {
            type: '0', // weekly
            title: '',
            taxonomy: '',
            format: 0,
            section_id: null,
            notes: '',
            taxonomy_notes: '',
            locked: 0,
            style: '',
            metric: '',
            inverted: false,
            ytd_formula: 'SUM'
        };
    }

    function cleanSection() {
        currentSection = {
            title: "",
            type: '0',
            organization_id: params.org
        };
    }

    function fillKPI(section) {
        jQuery('#kpi-tab').click();
        cleanKPI();
        currentKPI.section_id = section.id;
        sectionName = section.title;
        jQuery('#addKPI').modal('show');
    }

    function editKPI(e, kpi) {
        cleanKPI();
        deleteConfirmation = false;
        disableButton = false;
        jQuery('#kpi-tab').click();
        currentKPI = kpi;
        kpiToChange = { ...currentKPI };
        jQuery('#addKPI').modal('show');
    }

    function switchKPILock() {
        currentKPI.locked = currentKPI.locked === 1? 0: 1;
    }

    let showUnlockTooltip = function() {
        jQuery('#btnLock').tooltip('show');
        setTimeout(() => {
            jQuery('#btnLock').tooltip('hide');
        }, 5000);
    };

    async function handleDrop(e, section_id, position) {
        e.preventDefault();

        // remove borders styles
        e.target.style.borderTop = '';
        e.target.style.borderBottom = '';

        let id = e.dataTransfer.getData('text');

        // Add element below the target
        if (!ReportsService.isElementTopPosition(e)) position++;

        try {
            await ReportsService.updateKpiPosition({id, type: 0, section_id, position});
            loadData();
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Handle the drag over event to show the drop effect
     */
    function handleDragOver(e) {
        e.dataTransfer.dropEffect = 'move';

        if (ReportsService.isElementTopPosition(e)) {
            window.jQuery(e.target).css('border-top', '3px dashed #fdc59b');
            window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
            window.jQuery(e.target).css('border-bottom', '1px solid #dee2e6');
        } else {
            window.jQuery(e.target).css('border-bottom', '3px dashed #fdc59b');
            window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
            window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        }
        e.preventDefault();
    }

    function handleDragStart(e, id, sectionId) {
        sectionDragged = sectionId;
        kpiDragged = id;
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.setData("text", id);
    }

    /**
     * Remove border styles when leaving the drop area
     */
    function handleDragLeave(e) {
        window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        window.jQuery(e.target).css('border-bottom', '1px solid #dee2e6');
        window.jQuery(e.target).css('box-shadow', 'none');
    }

    function editSection(section){
        currentSection = section;
        deleteConfirmation = false;
        disableButton = false;
        sectionToChange = { ...currentSection }; //Used to verify if at least a field change
        jQuery('#editSection').modal('show');
    }

    export function addSection(){
        cleanSection();
        jQuery('#editSection').modal('show');
    }

    export async function exportToExcel() {
        const urlToExport = '/org/' + params.org + '/export/weekly/date/' + params.year + "/" + params.month;
        let result = null;
        loadingExport = true;

        try {
            result = await ReportsService.load(urlToExport);
            if (result && result.data){
                await ExportService.downloadKpi(result.data.sections, user.name, 'weekly-' + jQuery('#dropdownOrganizations').text() + "-" + params.year + '-' + params.month, false, result.data.headers);
            } else {
                console.log('No sections found');
            }
        } catch (e) {
            console.log('Error', e);
        }
        loadingExport = false;
    }

    let onDeleteSection = async function() {
        disableButton = true;
        errorMessage = null;

        try {
            await ReportsService.deleteSection(currentSection.id);
            jQuery('#editSection').modal('hide');
            deleteConfirmation = false;
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    async function changeSectionPosition(sectionId, newPosition){
        if(selectedSection != sectionId){
            try {
                await ReportsService.updateSectionPosition({id: selectedSection, position: newPosition});
                loadData();
            } catch (e) {
                console.log(e);
            }
        }
        selectedSection = null;
    }

    function onSelectSection(sectionId){
        selectedSection = sectionId;
        jQuery('.sticky-thead').addClass('d-none');
    }
</script>
<button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>

<div class="modal fade" id="addKPI" tabindex="-1" role="dialog" aria-labelledby="addKPILabel" aria-hidden="true">
    <div class="modal-dialog modal-650">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addKPILabel">
                    {#if currentKPI.id}
                        Edit KPI

                        {#if AuthService.can('UNLOCK_KPI') }
                            <button id="btnLock" class="btn btn-sm ml-auto" on:click={switchKPILock} data-toggle="tooltip" data-placement="right" title="Click here to unlock">
                                {#if currentKPI.locked === 1}
                                    <span class="fa fa-lock"></span>
                                {:else}
                                    <span class="fa fa-unlock text-warning"></span>
                                {/if}
                            </button>
                        {/if}
                    {:else}
                        <span class="text-muted">Add New KPI to</span>
                        <em class="text-dark bg-warning px-1">{sectionName}</em>
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('ANNOTATE_KPI') }
                    <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="kpi-tab"
                               data-toggle="tab" href="#kpi" role="tab" aria-controls="kpi" aria-selected="true">
                                KPI
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="notes-tab"
                               data-toggle="tab" href="#notes" role="tab" aria-controls="notes" aria-selected="false">
                                Notes
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="ytd-formula-tab"
                               data-toggle="tab" href="#ytdFormula" role="tab" aria-controls="ytdFormula" aria-selected="false">
                                YTD Formula
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="style-tab"
                               data-toggle="tab" href="#style" role="tab" aria-controls="style" aria-selected="false">
                                Conditional Formatting
                            </a>
                        </li>
                        {#if AuthService.can('EDIT_INSIGHT_METRICS')}
                            <li class="nav-item">
                            <a class="nav-link" id="insight_metrics-tab"
                                data-toggle="tab" href="#insight_metrics" role="tab" aria-controls="style" aria-selected="false">
                                Insight Metrics
                            </a>
                        </li>
                        {/if}
                    </ul>
                {/if}
                <form>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="kpi" role="tabpanel" aria-labelledby="kpi-tab">
                            {#if currentKPI.id}
                                <div class="form-group">
                                    <p><b>KPI ID:</b> {currentKPI.id} </p>
                                </div>
                            {/if}
                            <div class="form-group">
                                <label for="nameInput">Title</label>
                                <input bind:value={currentKPI.title} maxlength="64" type="text" class="form-control" id="nameInput" placeholder="Title">
                            </div>
                            <div class="form-group">
                                <label for="taxonmyInput">Taxonomy & Definitions</label>
                                <input bind:value={currentKPI.taxonomy} maxlength="128" type="text" class="form-control" id="taxonmyInput" placeholder="Taxonomy and Definitions">
                            </div>
                            <div class="form-group">
                                <label for="formatInput">Format:</label>
                                <select bind:value={currentKPI.format} class="form-control" id="formatInput">
                                    {#each formatTitles as name, id}
                                        <option value={id}>{name}</option>
                                    {/each}
                                </select>
                            </div>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="inverted" bind:checked={currentKPI.inverted}>
                                <label class="form-check-label" for="inverted">Inverted Values</label>
                            </div>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="showBudget" bind:checked={currentKPI.show_budget}>
                                <label class="form-check-label" for="showBudget">Show Budget</label>
                            </div>
                        </div>
                        {#if AuthService.can('ANNOTATE_KPI') }
                            <div class="tab-pane fade" id="notes" role="tabpanel" aria-labelledby="notes-tab">
                                <div class="form-group">
                                    <label for="notesInput">KPI</label>
                                    <textarea bind:value={currentKPI.notes} type="text" rows="4"
                                        class="form-control" id="notesInput" placeholder="Notes"></textarea>
                                </div>
                                <div class="form-group">
                                    <label for="taxonomy_notesInput">Taxonomy & Definitions</label>
                                    <textarea bind:value={currentKPI.taxonomy_notes} type="text" rows="4"
                                        class="form-control" id="taxonomy_notesInput" placeholder="Taxonomy Notes"></textarea>
                                </div>
                                <div class="form-group">
                                    <label for="commentsInput">Comments</label>
                                    <textarea bind:value={currentKPI.comments} type="text" rows="4"
                                        class="form-control" id="commentsInput" placeholder="This will be shown in the last column"></textarea>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="ytdFormula" role="tabpanel" aria-labelledby="ytd-formula-tab">
                                <div class="form-group">
                                    <label for="ytdFormulaInput">Calculate the YTD Formula using: </label>
                                    <select bind:value={currentKPI.ytd_formula} class="form-control" id="ytdFormulaInput">
                                        <option value="SUM">Summation</option>
                                        <option value="AVG">Average</option>
                                    </select>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="style" role="tabpanel" aria-labelledby="style-tab">
                                <div class="form-group">
                                    <label>
                                        <input type=radio name="customStyle"
                                               checked="{ !currentKPI.style || currentKPI.style.length == 0 }" on:click={() => currentKPI.style=''}>
                                        Default
                                    </label>
                                    <label class="ml-3">
                                        <input type=radio name="customStyle"
                                               checked="{ currentKPI.style && currentKPI.style.length > 0 }" on:click={() => currentKPI.style=stylesList[0].code}>
                                        Custom
                                    </label>
                                </div>
                                {#if currentKPI.style && currentKPI.style.length > 0 }
                                    <ColorPicker bind:value={currentKPI.style} bind:inverted={currentKPI.inverted}></ColorPicker>
                                {/if}
                            </div>
                            <div class="tab-pane fade" id="insight_metrics" role="tabpanel" aria-labelledby="style-tab">
                                <div class="form-group">
                                    <label>
                                        <input type=radio name="customMetric"
                                            checked="{ !currentKPI.metric || currentKPI.metric.length == 0 }" on:click={() => currentKPI.metric=''}>
                                        Disabled
                                    </label>
                                    <label class="ml-3">
                                        <input type=radio name="customMetric"
                                            checked="{ currentKPI.metric && currentKPI.metric.length > 0 }" on:click={() => currentKPI.metric = metricList.monthly}>
                                        Enabled
                                    </label>
                                </div>
                                {#if currentKPI.metric && currentKPI.metric.length > 0 && AuthService.can('EDIT_INSIGHT_METRICS')}
                                    <InsightMetricsBuilder bind:value={currentKPI.metric} reportType='weekly'></InsightMetricsBuilder>
                                {/if}
                            </div>
                        {/if}
                    </div>
                </form>
            </div>
            {#if errorMessage}
                <div class="alert alert-danger">
                    ERROR: {errorMessage}
                </div>
            {/if}
            <div class="modal-footer">
                {#if AuthService.can('DELETE_KPI') }
                    {#if currentKPI.id}
                        {#if currentKPI.locked}
                             <button type="button" class="btn btn-danger mr-auto disabled" on:click={showUnlockTooltip} >
                                <i class="fa fa-lock mr-2"></i> DELETE
                            </button>
                         {:else if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteKPI} disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanKPI}>Close</button>

                <button type="button" class="btn btn-success" on:click={onSaveKPI} disabled={disableSaveButton}>
                    {#if currentKPI.id}
                        Update
                    {:else}
                        Save
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editSection" tabindex="-1" role="dialog" aria-labelledby="editSection" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editSectionLabel">
                    {#if currentSection.id}
                        Edit
                    {:else}
                        Add
                    {/if} section
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('EDIT_TEAM') }
                    <label for="teamName">Name:</label>
                    <input bind:value={currentSection.title} maxlength="64" type="text" class="form-control" id="sectionName" placeholder="Section Name">
                    {#if !currentSection.title}
                        <small class="text-danger ml-2 font-weight-bold">Name is required</small>
                    {/if}
                {/if}
            </div>
            <div class="modal-footer text-right">
                {#if AuthService.can('DELETE_SECTION') }
                    {#if currentSection.id}
                        {#if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteSection} disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                {#if currentSection.title}
                    <button type="button" class="btn btn-success " on:click={onSaveSection} disabled={disableSaveButton}>
                        {#if currentSection.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                {:else}
                    <button type="button" class="btn btn-danger disabled" disabled={disableSaveButton}>
                        {#if currentSection.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader fixed={true}></Loader>
{/if}

{#if !sections}
    <h4 class="text-danger text-center">...</h4>
{:else}
    <div id="popover-notes" class="comment-popover d-none" ></div>
    <div id="popover-comments" class="comment-popover d-none" >
        <div id="close-comments" class="text-right text-primary pointer h6 font-weight-bold">X</div>
        <div id="comments-body"></div>
    </div>
    <div id="popover-metric" class="alert alert-danger d-none" ></div>
    {#each sections as section, sectionIndex}
        {#if section.position !== null}
            {#if selectedSection}
                <div class="move-here"
                    on:click={ changeSectionPosition(section.id, section.position) }>
                    Click here to move it
                </div>
            {/if}
            <div class="table-wrapper { selectedSection && selectedSection == section.id ? 'selectedSection' : ''}">
                <table class="table table-sm container-fluid table-weekly selectable-table">
                    <thead>
                        <tr class="{section.position !== null? 'bg-dark': 'bg-danger'} text-light ">
                            <th class="{section.position !== null? 'col-header': 'bg-danger'}">
                                {section.title}
                                {#if section.position !== null && AuthService.can('EDIT_SECTION') }
                                    <i on:click={ () =>  editSection(section)}
                                        class="fa fa-pencil-square-o text-light float-right btn btn-sm px-0"></i>
                                    {#if !selectedSection}
                                        <i
                                            class="fa fa-arrows pointer mr-1 mt-1 float-right"
                                            on:click={ onSelectSection(section.id)}
                                        ></i>
                                    {/if}
                                {/if}
                            </th>
                            <th class="col-subheader">Taxonomy & Def.</th>
                            <th class="col-info weekly-type">Type</th>
                            <th class="col-info">YTD</th>
                            {#each headers as id}
                                <th class="notFixed">{id}</th>
                            {/each}
                            <th class="col-comments notFixed">Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                    {#each section.kpis as kpi, kpiIndex}
                        <tr>
                            <th class="col-header rowDropArea {(kpi.insight_metric_data.message) ? 'alert alert-danger' : ''}"
                                draggable="true"
                                on:dragstart={(e) => handleDragStart(e, kpi.id, section.id) }
                                on:dragover={(e) => (sectionDragged === section.id && kpiDragged !== kpi.id? handleDragOver(e): true)}
                                on:dragleave={(e) => (sectionDragged === section.id && kpiDragged !== kpi.id? handleDragLeave(e): true)}
                                on:drop={(e) => (sectionDragged === section.id && kpiDragged !== kpi.id? handleDrop(e, section.id, kpiIndex): true) }>
                                {#if kpi.notes && kpi.notes.length > 0}
                                    <i data-notes="{kpi.notes}"
                                    class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                {/if}
                                {#if AuthService.can('EDIT_KPI') }
                                    {#if kpi.locked === 1}
                                        {#if AuthService.can('UNLOCK_KPI') }
                                            <i data-id="{kpi.id}" on:click={ (e) => editKPI(e, kpi) }
                                            class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                        {/if}
                                        <span class="fa fa-lock text-warning float-right btn btn-sm px-0 not-allowed"></span>
                                    {:else}
                                        <i data-id="{kpi.id}" on:click={ (e) => editKPI(e, kpi) }
                                        class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                    {/if}
                                {/if}
                                <i data-message={kpi.insight_metric_data.message}
                                    class="fa fa-warning text-danger float-right btn btn-sm px-0 mr-1 action-metric {(kpi.insight_metric_data.message) ? '' : 'd-none'}">
                                </i>
                                {#if section.position === null && kpi.code}<span class="text-danger">{kpi.code}</span>{/if}
                                {kpi.title}
                            </th>
                            <td class="col-subheader">
                                {#if kpi.taxonomy_notes && kpi.taxonomy_notes.length > 0}
                                    <i data-notes="{kpi.taxonomy_notes}"
                                    class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                {/if}
                                {kpi.taxonomy || '' }
                            </td>
                            <td class="col-info"><small>Actual{#if kpi.show_budget}<hr>Budget{/if}</small></td>
                            <td class="readOnly notFixed">
                                <div class="{getActualClass(kpi.style, { actual: ytdValues[kpi.id].actual, budget: ytdValues[kpi.id].budget }, 'weekly', `${params.year}-01-01`, params.year, kpi.inverted)}">
                                    { formatValue(kpi.format, ytdValues[kpi.id].actual) }
                                </div>
                                {#if kpi.show_budget}
                                    <hr>
                                    { formatValue(kpi.format, ytdValues[kpi.id].budget) }
                                {/if}
                            </td>
                            {#if kpi.kpiData }
                                {#each Object.keys(kpi.kpiData) as id, kpiDataIndex}
                                    <td on:click={() => selectedKpiCell = kpi} class="{ AuthService.can('EDIT_KPI')? 'notFixed': 'readOnly'} ">
                                        {#if section.position !== null && AuthService.can('EDIT_CELL') }
                                            <EditableCell
                                                customClass="{ getActualClass(kpi.style, kpi.kpiData[id], 'weekly', id, params.year, kpi.inverted)} {(!kpi.kpiData[id].actual_imported)?'manual-data-kpi':''}"
                                                id="t{sectionIndex}-{kpiIndex*2}-{kpiDataIndex}"
                                                xdata="{ {id: kpi.id, report: 'weekly', date: id, field: 'actual', value: kpi.kpiData[id].actual } }"
                                                on:change={(e) => saveKPIData(e.detail.value, kpi.id, id, kpi.kpiData[id].actual, kpi.kpiData[id].budget, "t"+ sectionIndex +"-"+kpiIndex*2+"-"+kpiDataIndex, 'actual', kpi)}
                                                bind:value={kpi.kpiData[id].actual}
                                                format={kpi.format}></EditableCell>
                                            {#if kpi.show_budget}
                                                <hr>
                                                <EditableCell
                                                    customClass="{(!kpi.kpiData[id].budget_imported)?'manual-data-kpi':''} {(kpi.kpiData[id].actual > 0 && kpi.kpiData[id].budget == 0) ?'style-red' : '' } {getPastDateData(kpi.kpiData[id].budget, id , 'weekly')}"
                                                    id="t{sectionIndex}-{(kpiIndex*2) + 1}-{kpiDataIndex}"
                                                    xdata="{ {id: kpi.id, report: 'weekly', date: id, field: 'budget', value: kpi.kpiData[id].budget} }"
                                                    on:change={(e) => saveKPIData(e.detail.value, kpi.id, id, kpi.kpiData[id].actual, kpi.kpiData[id].budget, "t"+ sectionIndex +"-"+(kpiIndex*2 +1 )+"-"+kpiDataIndex, 'budget', kpi)}
                                                    bind:value={kpi.kpiData[id].budget}
                                                    format={kpi.format}></EditableCell>
                                            {/if}
                                        {:else}
                                            <div id="t{sectionIndex}-{kpiIndex*2}-{kpiDataIndex}"
                                                class="{ getActualClass(kpi.style, kpi.kpiData[id], 'weekly', id, params.year, kpi.inverted)} {(!kpi.kpiData[id].actual_imported)?'manual-data-kpi':''}"
                                            >
                                                { formatValue(kpi.format, kpi.kpiData[id].actual) }
                                            </div>
                                            {#if kpi.show_budget}
                                                <hr>
                                                <div id="t{sectionIndex}-{(kpiIndex*2) + 1}-{kpiDataIndex}"
                                                    class ="{(!kpi.kpiData[id].budget_imported)?'manual-data-kpi':''} {(kpi.kpiData[id].actual > 0 && kpi.kpiData[id].budget == 0) ?'style-red' : '' } {getPastDateData(kpi.kpiData[id].budget, id , 'weekly')}"
                                                >
                                                    { formatValue(kpi.format, kpi.kpiData[id].budget) }
                                                </div>
                                            {/if}
                                        {/if}
                                    </td>
                                {/each}
                            {:else}
                                <td class="text-danger">No data</td>
                            {/if}
                            <td class="col-comments notFixed readOnly">
                                <span data-comments="{kpi.comments || ''}" class="text-primary comments-truncate weekly pointer full-comments">
                                    {kpi.comments || ''}
                                </span>
                            </td>
                        </tr>
                    {:else}
                        <tr>
                            <th class="col-header">
                                ---
                            </th>
                            <td class="col-subheader">---</td>
                            <td class="col-info"><small>---</small></td>
                            <td class="col-info"><small>---</small></td>
                            {#each headers as header}
                                <td class="notFixed readOnly text-light">&emsp; </td>
                            {/each}
                        </tr>
                    {/each}
                        <tr class="border-0">
                            <th class="bg-transparent col-header">
                                {#if section.position !== null && AuthService.can('ADD_KPI') }
                                    <button class="mt-2 btn btn-primary btn-sm text-light float-left"
                                            data-id="{section.id}"
                                            on:click|preventDefault={(e) => fillKPI(section)}>
                                        <i class="fa fa-plus"></i>
                                        Add KPI
                                    </button>
                                {/if}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        {/if}
    {/each}
{/if}
